import ServicePage from "../ServicePage";
import { servicesData } from "@/mocks/services";

export default function PackVentePage() {
  return <ServicePage data={servicesData["pack-vente"]} />;
}
